import React from "react";
import AntdLayout, {LayoutProps} from "antd/lib/layout";
import { withError} from '@fishx/tracker';

const Header = AntdLayout.Header;
const Content = AntdLayout.Content;
const Footer = AntdLayout.Footer;
const Sider = AntdLayout.Sider;

interface FCLayoutProps extends React.FC<LayoutProps> {
  Header: typeof Header;
  Content: typeof Content;
  Footer: typeof Footer;
  Sider: typeof Sider;
}
export const Layout: FCLayoutProps = (props) => {
  return <AntdLayout {...props} />;
}
Layout.Header = Header;
Layout.Content = Content;
Layout.Footer = Footer;
Layout.Sider = Sider;
Layout.displayName = 'Layout';
export default withError(Layout);



// WEBPACK FOOTER //
// ./src/components/layout/index.tsx